import { Injectable, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';

import { TopicsService } from '../../../Monitor/Core/services/topics.service';
import { MentionSearchListItemModel } from '../../../Monitor/Shared/models/mention-search-list-item.model';
import { ReportSeriesModel } from '../../Reports/models/report-series.model';
import { SeriesTypeEnum } from '../../Reports/enums/series-type.enum';

@Injectable()
export class BaseSeriesService implements OnDestroy {

    topics: MentionSearchListItemModel[];

    subscriptions: Subscription[];

    constructor(public topicsService: TopicsService) {
        this.setSubscriptions();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(
            subscription => {
                subscription.unsubscribe();
            }
        );
    }

    setSubscriptions(): void {
        this.subscriptions = [];
        this.subscriptions.push(
            this.topicsService.getTopics().subscribe(
                (topics) => {
                    if (topics) {
                        this.topics = topics ? topics.slice() : [];

                        this.topics.sort(this.sortByDate);
                    }
                }
            )
        );
    }

    /**
     * Sorts an list by modified date (or created date, if modified date is not available)
     */
    sortByDate(a, b): number {
        return (+b.modifiedDate || +b.createdDate) - (+a.modifiedDate || +a.createdDate);
    }

    /**
     * depending on the series type, will assign the correct data to the series
     */
    setSeries(series: ReportSeriesModel) {
        if (series.type === SeriesTypeEnum.topic) {
            this.assignTopicToSeries(series);
        }
    }

    assignTopicToSeries(series: ReportSeriesModel) {
        if (series.hasOwnProperty('dataIndex') && this.topics && this.topics[series.dataIndex]) {
            series.mentions.topicId = this.topics[series.dataIndex].id;
            series.label = `${this.topics[series.dataIndex].name}`;
        }
    }
}
